export const SOCKET_ENDPOINT = window.location.hostname === "localhost"
  ? "http://localhost:4000" 
  : "https://socially-u07q.onrender.com";

export const stories = [
  {
    title: "JavaScript",
    image: "javascript",
  },
  {
    title: "Node.js",
    image: "nodejs",
  },
  {
    title: "Express.js",
    image: "expressjs",
  },
  {
    title: "MongoDB",
    image: "mongodb",
  },
  {
    title: "React.js",
    image: "reactjs",
  },
  {
    title: "Socket.io",
    image: "socketio",
  },
  {
    title: "TailwindCSS",
    image: "tailwind",
  },
  {
    title: "MaterialUI",
    image: "mui",
  },
  {
    title: "Redux",
    image: "redux",
  },
  {
    title: "Multer",
    image: "multer",
  },
  {
    title: "Axios",
    image: "axios",
  },
  {
    title: "Toastify",
    image: "toastify",
  },
];
